import React from "react";
import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <div
    className="grid justify-items-center items-center"
    >
      <Typography variant="h4" >
        {t("contact.before")}{" "}
        <a href="tel:+919912671999" className="bg-gray-500 text-blue-100">
          +91 - 99 126 71 999
        </a>{" "}
        {t("contact.after")}
      </Typography>
    </div>
  );
};

export default Contact;
